import React from 'react';
import leavesLeft from '../../../assets/images/leaves-left.svg';
import leavesRight from '../../../assets/images/leaves-right.svg';

interface SpecialLineProps {
  text: string;
  className?: string;
  color?: 'white' | 'default';
}

export function SpecialLine({ text, className = '', color = 'default' }: SpecialLineProps) {
  const textColorClass = color === 'white' ? 'text-white' : 'text-[#361e06]';
  const filterClass = color === 'white' ? 'brightness-0 invert' : '';

  return (
    <div className={`flex items-center justify-center gap-3 ${className}`}>
      <img src={leavesLeft} alt="" className={`h-[24px] ${filterClass}`} />
      <span className={`text-lg sm:text-lg font-semibold ${textColorClass}`}>
        {text}
      </span>
      <img src={leavesRight} alt="" className={`h-[24px] ${filterClass}`} />
    </div>
  );
} 